import React, { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'

type LanguageType = 'de' | 'fr'
type StatusType = 'activated' | 'deactivated'
const Labels: { [k in LanguageType]: { [K in StatusType]: string } } = {
  de: { deactivated: 'Karte aktivieren', activated: 'Scrollen aktivieren' },
  fr: { deactivated: 'Activer la carte', activated: 'Activer le défilement' },
}

export const InteractiveToggle = ({
  language = 'de',
  change,
}: {
  language?: 'de' | 'fr'
  change: (e: boolean) => void
}) => {
  const [isActive, setActive] = useState<'activated' | 'deactivated'>(
    'deactivated'
  )
  useEffect(() => {
    if (!change) return
    change(isActive === 'activated' ? true : false)
  }, [isActive])
  return (
    <Button
      isActive={isActive === 'activated'}
      onClick={() => {
        setActive(isActive === 'activated' ? 'deactivated' : 'activated')
      }}
    >
      {Labels[language][isActive]}
    </Button>
  )
}

const Button = styled.button<{ isActive: boolean }>`
  position: absolute;
  transition: right 0.2s ease;
  right: ${({ isActive }) => (isActive ? '50px' : '10px')};
  top: 10px;
  z-index: 900;
  border: 0;
  padding: 1rem 1.5rem;
  background-color: ${({ isActive }) =>
    isActive ? 'var(--red-main)' : 'var(--brandblue-main)'};
  color: #fff;
  font-family: var(--font-plex);
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.2px;
  &:hover {
    cursor: pointer;
    background-color: ${({ isActive }) =>
      isActive ? 'var(--red-bright-1)' : 'var(--brandblue-bright-1)'};
  }
  @media only screen and (max-width: 711px) {
    right: ${({ isActive }) => (isActive ? '50px' : '0px')};
  }
`
